import { FC, useCallback, useState } from "react"
import { androidBuildDeleteApi } from "src/domain/api/androidBuild/androidBuildDeleteApi"
import { AndroidBuild } from "src/domain/entities/androidBuild"
import { useAuth } from "../../../domain/hooks"
import { getErrorMessage } from "../../../utils/helpers"
import DeleteItemDialog from "../../shared/DeleteItemDialog"

interface Props {
	androidBuild: AndroidBuild
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const AndroidBuildDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	androidBuild,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleAndroidBuildDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await androidBuildDeleteApi({ id: androidBuild.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [androidBuild, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete Android Build: ${androidBuild.version}(${androidBuild.buildNo})`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleAndroidBuildDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
